import React from 'react';
import Text, { Inline } from 'components/base/Text';
import { LINE_HEIGHT } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';
import _ from 'lodash';

const EditableInline = styled(Inline)`
  ${({ estimateNumber }) =>
    estimateNumber > 3 ? `color: ${getColor('amaranth')};` : ``};
`;
const TrackingCol = ({ description, estimateNumber, isShowEstimation }) => {
  const isShowEstimationLine = !isNaN(estimateNumber) && isShowEstimation;
  estimateNumber = _.round(estimateNumber);
  return (
    <>
      <Text size='small' lineHeight={LINE_HEIGHT.small} pb='0.3rem'>
        {description}
      </Text>
      {isShowEstimationLine &&
        (estimateNumber > 0 ? (
          <Inline>
            Estimated:
            <EditableInline
              estimateNumber={estimateNumber}
              data-testid='estimateNumber'
            >
              {' '}
              {estimateNumber} daily notifications
            </EditableInline>
          </Inline>
        ) : (
          <Inline data-testid='less-than-1'>
            Estimated: less than 1 notification per day
          </Inline>
        ))}
    </>
  );
};

export default TrackingCol;
